<template>
    <div class="repair__form">
        <div class="title">
            <h2>Оставить заявку</h2>
            <h3>{{ offerName }}</h3>
        </div>
        <div class="form">
            <div class="inputs">
                <input-styled
                        name="name"
                        :placeholderInput="'Название объекта и имя заказчика'"
                        v-model="form.name.value"
                        :auto-focus="true"
                        :max-length="50"
                        @focus="form.name.error=false"
                        @removeError="form.name.error=false"
                        :errorText="form.name.errorText"
                        :is-error="form.name.error">
                </input-styled>
                <div class="flex-row">
                    <div class="fixed-width">
                        <input-styled
                                class="phone-field"
                                name="phone"
                                :placeholderInput="'Телефон заказчика'"
                                :inputmode="'tel'"
                                :type="'tel'"
                                :mask="{mask:'+7(999)999-99-99',showMaskOnHover: false}"
                                v-model="form.phone.value"
                                @focus="form.phone.error=false"
                                @removeError="form.phone.error=false"
                                @blur="form.phone.error=false"
                                :errorText="form.phone.errorText"

                                :is-error="form.phone.error">
                        </input-styled>
                    </div>
                </div>
                <textarea-field
                        v-model="form.comment.value"
                        :is-error="form.comment.error"
                        @removeError="form.comment.error=false"
                        class="full"
                        :error-text="'Обязательное поле'"
                        :auto-focus="false"
                        placeholder="Комментарий к заявке"
                        :add-style="{minHeight:'240px'}">
                </textarea-field>
            </div>
            <submit-btn @click="send()" class="repairSubmit" tag="button" :size="'large'">
                Отправить
            </submit-btn>
        </div>
        <div class="notification" :class="{'active':animNotification}" v-show="isShowNotification">
            Заявка успешно отправлена
        </div>
    </div>
</template>


<script>
import Repair from '@baza/helpers/mixins/repair';
import SvgIcon from '@baza/components/SvgIcon.vue';
import InputStyled from '@baza/components/forms/InputStyled.vue';
import TextareaField from '@baza/components/forms/TextareaField.vue';
import SubmitBtn from '@baza/components/forms/SubmitBtn.vue';
import CheckItem from '@baza/components/forms/CheckItem.vue';

export default {
    name: 'RepairForm',
    mixins: [Repair],
    components: {
        SvgIcon,
        InputStyled,
        TextareaField,
        SubmitBtn,
        CheckItem,
    },
    props: {
        item: {
            default: {},
        },
    },
    data() {
        return {
            btnType: 'normal',
            dispatch: 'offer/sendOrder',
            isShowNotification: false,
            animNotification: false,
        };
    },
    mounted() {
        this.$store.dispatch('offer/getHiddenFormOffer', this.$route.params.id);
    },
    computed: {
        offerName(){
            return this.$store.state.offer.hiddenFormOffer.name || ''
        },
        apiKey(){
            return this.$store.state.offer.hiddenFormOffer.api_key
        },
        offerId(){
            return this.$store.state.offer.hiddenFormOffer.id
        }
    },
    watch: {

    },
    methods: {
        getData() {
            const result = {
                api_key:  this.apiKey,
                offer_id: this.offerId,
                is_mobile: false,
            };
            for (const f in this.form) {
                if (this.form[f].type === 'phone') {
                    result[f] = this.form[f].value.replace('+7', '8');
                } else {
                    result[f] = this.form[f].value;
                }
            }
            return result;
        },
        clearForm(){
            for (const f in this.form) {
                this.form[f].value = ''
            }
        },
        triggerNotification() {
            this.isShowNotification = true;

            setTimeout(() => {
                this.animNotification = true;
            }, 10);

            setTimeout(() => {
                this.animNotification = false;

                setTimeout(() => {
                    this.isShowNotification = false;
                }, 300);
            }, 3000);
        },
        send() {
            if (this.validate()) {
                this.status = 'load';
                this.$store.dispatch(this.dispatch, this.getData()).then((r) => {
                    this.status = 'normal';
                    this.triggerNotification()
                    this.clearForm()

                });
            }
        },
    },
};
</script>

<style lang="sass">
.repair__form
    background: $black1
    width: 100%
    min-height: 100vh
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    gap: 32px
    padding: 24px
    +for-size(992)
        padding: 48px
    .title
        display: flex
        flex-direction: column
        align-items: center
        gap: 12px
        h2
            font-family: "Oswald", sans-serif
            font-weight: 700
            font-size: 48px
            line-height: 100%
            letter-spacing: 1.1px
            text-align: center
            vertical-align: bottom
            text-transform: uppercase
            color: $gray-light2

        h3
            font-weight: 700
            font-size: 20px
            line-height: 120%
            letter-spacing: 0.5px
            color: $gray-light2


    .form
        width: 100%
        display: flex
        flex-direction: column
        align-items: center
        gap: 64px
        +for-size(992)
            width: 704px
        .inputs
            display: flex
            flex-direction: column
            gap: 24px
            width: 100%
            +for-size(992)
                width: 576px
            .textarea-field
                &.full
                    font-size: 16px
        .repairSubmit
            box-shadow: 0px 4px 20px 0px #F09A1633
    .notification
        font-family: 'Montserrat', sans-serif
        position: fixed
        right: 48px
        bottom: -68px
        background: #fff
        width: 280px
        text-align: center
        border-radius: 4px
        padding: 24px
        box-shadow: 0px 0px 8px 0px #2828284D
        font-size: 14px
        color: #545454
        transition: all 0.3s ease
        &.active
            bottom: 48px



</style>

